// PrivacyPolicy.jsx
import React from "react";

const PrivacyPolicy = () => {
  return (
    <div
      style={{
        maxWidth: 800,
        margin: "0 auto",
        padding: 20,
        fontFamily: "Arial, sans-serif",
      }}
    >
      <h1 style={{ textAlign: "center" }}>Privacy Policy</h1>
      <p>
        <strong>App Name:</strong> BYDhelp
      </p>
      <p>
        <strong>Developer:</strong> Karen Soghoyan
      </p>

      <h2>1. No Collection of Personal Data</h2>
      <p>
        BYDhelp does not collect, store, or share any personal information or
        sensitive user data. The application is designed solely to monitor and
        control specific functions of BYD vehicles.
      </p>

      <h2>2. Data Usage and Encryption</h2>
      <p>
        All communication between the app and the vehicle systems is secured
        using encryption protocols. No data is transmitted to any external
        server or third-party service.
      </p>

      <h2>3. Local Device Communication</h2>
      <p>
        The app only communicates locally with the vehicle's system using secure
        channels. No external API calls or remote logging are involved.
      </p>

      <h2>4. Third-Party Services</h2>
      <p>
        BYDhelp does not integrate with any third-party analytics, advertising,
        or tracking services.
      </p>

      <h2>5. Changes to Privacy Policy</h2>
      <p>
        If the privacy policy is updated in the future, users will be notified
        within the app interface or through an official app update.
      </p>

      <h2>6. Contact</h2>
      <p>
        If you have any questions regarding this privacy policy, you can contact
        the developer at: <br />
        <strong>Karen Soghoyan https://t.me/BydKsoghoyan</strong>
      </p>
    </div>
  );
};

export default PrivacyPolicy;
